



























































import { Vue, Component } from "vue-property-decorator";
import Auth from "@aws-amplify/auth";
import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "@/graphql/mutations";
import * as queries from "@/graphql/queries";
import * as graphqlTypes from "@/@types/graphql";
import { accountInfoModule } from "@/store/accountInfo";

@Component({})
export default class Enquete extends Vue {
  private show_alert: boolean = false;
  private variant_type: string = "success";
  private message: string = "initial";
  private age: string = "";
  private job: string = "";
  private living_area: string = "";
  private living_area_text: string = "";
  private license: string[] = [];
  private license_text: string = "";
  private hoiku_keiken: string = "";
  private kosodate_keiken: string = "";
  private kibou_style: string = "";
  private kibou_salary: string = "";
  private kibou_bonus: string = "";
  private offer: string = "";
  private owner: string = "";
  private _version: number = 0;

  private age_options = [
    {
      value: "20",
      text: "20～25歳"
    },
    {
      value: "26",
      text: "26～30歳"
    },
    {
      value: "31",
      text: "31～35歳"
    },
    {
      value: "36",
      text: "36～40歳"
    },
    {
      value: "41",
      text: "41歳以上"
    }
  ];
  private job_options = [
    {
      value: "student",
      text: "学生"
    },
    {
      value: "adult1",
      text: "社会人(保育系)"
    },
    {
      value: "adult2",
      text: "社会人(保育以外)"
    },
    {
      value: "adult3",
      text: "休職中"
    }
  ];
  private living_area_options = [
    {
      value: "tokyo1",
      text: "東京(23区内)"
    },
    {
      value: "tokyo2",
      text: "東京(23区外)"
    },
    {
      value: "other",
      text: "その他"
    }
  ];
  private license_options = [
    {
      value: "hoikushi",
      text: "保育士"
    },
    {
      value: "youichien_kyoyu",
      text: "幼稚園教諭"
    },
    {
      value: "jidou_shidouin",
      text: "児童指導員"
    },
    {
      value: "kangoshi",
      text: "看護師"
    },
    {
      value: "eiyoushi",
      text: "栄養士"
    },
    {
      value: "other",
      text: "その他"
    }
  ];
  private hoiku_keiken_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private kosodate_keiken_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private kibou_style_options = [
    {
      value: "seiki",
      text: "正規職員"
    },
    {
      value: "part1",
      text: "パート・アルバイト(フルタイム)"
    },
    {
      value: "part2",
      text: "パート・アルバイト(短時間)"
    },
    {
      value: "ok",
      text: "どれでも"
    }
  ];
  private kibou_salary_options = [
    {
      value: "8",
      text: "8万以下(扶養内)"
    },
    {
      value: "10",
      text: "10～15万円"
    },
    {
      value: "16",
      text: "16～20万円"
    },
    {
      value: "21",
      text: "21～25万円"
    },
    {
      value: "26",
      text: "26～30万円"
    },
    {
      value: "31",
      text: "31万円以上"
    }
  ];
  private kibou_bonus_options = [
    {
      value: "ari",
      text: "あり"
    },
    {
      value: "nashi",
      text: "なし"
    }
  ];
  private offer_options = [
    {
      value: "direct",
      text: "直接連絡を受ける"
    },
    {
      value: "indirect",
      text: "弊社を通して受ける"
    },
    {
      value: "no",
      text: "受けない"
    }
  ];
  set enquete1(json: string) {
    try {
      const obj = JSON.parse(json);
      const objkeys = Object.keys(obj);
      if (objkeys.indexOf("age") >= 0) this.age = obj["age"];
      if (objkeys.indexOf("job") >= 0) this.job = obj["job"];
      if (objkeys.indexOf("living_area") >= 0) this.living_area = obj["living_area"];
      if (objkeys.indexOf("living_area_text") >= 0) this.living_area_text = obj["living_area_text"];
      if (objkeys.indexOf("license") >= 0) this.license = obj["license"];
      if (objkeys.indexOf("license_text") >= 0) this.license_text = obj["license_text"];
      if (objkeys.indexOf("hoiku_keiken") >= 0) this.hoiku_keiken = obj["hoiku_keiken"];
      if (objkeys.indexOf("kosodate_keiken") >= 0) this.kosodate_keiken = obj["kosodate_keiken"];
      if (objkeys.indexOf("kibou_style") >= 0) this.kibou_style = obj["kibou_style"];
      if (objkeys.indexOf("kibou_salary") >= 0) this.kibou_salary = obj["kibou_salary"];
      if (objkeys.indexOf("kibou_bonus") >= 0) this.kibou_bonus = obj["kibou_bonus"];
      if (objkeys.indexOf("offer") >= 0) this.offer = obj["offer"];
    } catch (e) {
      // console.log(json);
    }
  }
  get enquete1(): string {
    return JSON.stringify({
      age: this.age,
      job: this.job,
      living_area: this.living_area,
      living_area_text: this.living_area_text,
      license: this.license,
      license_text: this.license_text,
      hoiku_keiken: this.hoiku_keiken,
      kosodate_keiken: this.kosodate_keiken,
      kibou_style: this.kibou_style,
      kibou_salary: this.kibou_salary,
      kibou_bonus: this.kibou_bonus,
      offer: this.offer
    });
  }
  async mounted() {
    await this.loadData();
  }
  async createData() {
    const createMutation: any = {
      input: {
        id: accountInfoModule.getUserId,
        enquete1: this.enquete1,
        owner: accountInfoModule.getUserId
      }
    };
    try {
      return await API.graphql(graphqlOperation(mutations.createPrivateEnquete, createMutation));
    } catch (err) {
      // console.log(err);
    }
  }
  async setData() {
    const updateMutation: graphqlTypes.UpdatePrivateEnqueteMutationVariables = {
      input: {
        id: accountInfoModule.getUserId,
        enquete1: this.enquete1,
        _version: this._version
      }
    };
    try {
      const result: any = await API.graphql(graphqlOperation(mutations.updatePrivateEnquete, updateMutation));
      if (result && result.data && result.data.updatePrivateEnquete) {
        this.enquete1 = result.data.updatePrivateEnquete.enquete1;
        this._version = result.data.updatePrivateEnquete._version;
        this.message = "ご登録ありがとうございました。";
        this.show_alert = true;
      }
    } catch (err) {
      this.show_alert = true;
      this.variant_type = "danger";
      this.message = "登録に失敗しました。" + JSON.stringify(err);
    }
  }
  async loadData() {
    try {
      const response: any = await API.graphql(
        graphqlOperation(queries.getPrivateEnquete, { id: accountInfoModule.getUserId })
      );
      if (response && response.data && response.data.getPrivateEnquete) {
        this.enquete1 = response.data.getPrivateEnquete.enquete1;
        this._version = response.data.getPrivateEnquete._version;
        this.owner = response.data.getPrivateEnquete.owner;
      } else {
        throw "maybe_no_data";
      }
    } catch (e) {
      //一般ユーザがgetに失敗したらthrowされるぽい。
      const result: any = await this.createData();
      if (result && result.data && result.data.createPrivateEnquete) {
        this._version = result.data.createPrivateEnquete._version;
        this.owner = result.data.createPrivateEnquete.owner;
      }
    }
  }
}
